module.exports = __webpack_public_path__ + "media/images/TOY_DHD_Hauptgewinn-Yaris-1000-d1e0aff879fdfd7536da723345457bcc.jpg";